import { DateTime } from 'luxon';

export default function formatDateMMDDYYYY(date: string): string {
  const unixDate = new Date(date);
  return `${
    unixDate.getMonth() + 1
  }/${unixDate.getDate()}/${unixDate.getFullYear()}`;
}

export function formatDateMMDDYYYYTime(date: string): string {
  return `${DateTime.fromISO(date).toFormat('f')} ${DateTime.fromISO(
    date
  ).toFormat('ZZZZ')}`;
}
